import { render } from "./PortalAteliers.vue?vue&type=template&id=cf5a13e2&scoped=true&ts=true"
import script from "./PortalAteliers.vue?vue&type=script&lang=ts"
export * from "./PortalAteliers.vue?vue&type=script&lang=ts"

import "./PortalAteliers.vue?vue&type=style&index=0&id=cf5a13e2&scoped=true&lang=css"

import exportComponent from "/home/gitlab-deployer/builds/Bp7u02vYG/0/erp/admissibles-front/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf5a13e2"]])

export default __exports__